import { useColumnValues } from '@hooks/useQuery'
import type { BlueprintNode } from 'src/types/queries'

interface ColumnValuesDatalistProps {
  blueprint: BlueprintNode
  column: string
  id: string
  filter: string
  exclude?: string[]
}

const MAX_OPTIONS = 50

export const ColumnValuesDatalist = ({
  blueprint,
  column,
  id,
  filter,
  exclude
}: ColumnValuesDatalistProps) => {
  const values = useColumnValues(blueprint, column)
  const needle = filter.toLowerCase()
  const excludeSet = new Set(exclude ?? [])
  const options = values
    .filter((v) => !excludeSet.has(v) && v.toLowerCase().includes(needle))
    .slice(0, MAX_OPTIONS)

  return (
    <datalist id={id}>
      {options.map((v) => (
        <option key={v} value={v} />
      ))}
    </datalist>
  )
}
